module.exports = "../static/media/icon_mf.3fd0e2da.png";